import React from "react";

const shareFmt = new Intl.NumberFormat("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt = (n) => shareFmt.format(Number(n || 0));

export default function ShareBalanceBar({
  held = 0,
  locked = 0,
  available = 0,
  redeemed = 0,
  label,
}) {
  const total = Math.max(Number(held) || 0, 0.01);
  const lockedPct = Math.min(100, (Number(locked) / total) * 100);
  const availPct = Math.min(100 - lockedPct, (Number(available) / total) * 100);
  const otherPct = Math.max(0, 100 - lockedPct - availPct);

  return (
    <div className="investor-share-bar">
      {label ? (
        <div className="investor-share-bar__labels">
          <span>{label}</span>
        </div>
      ) : null}
      <div className="investor-share-bar__track" role="img" aria-label={`Held ${fmt(held)}, locked ${fmt(locked)}, available ${fmt(available)}`}>
        <span className="investor-share-bar__seg--held" style={{ width: `${otherPct}%` }} />
        <span className="investor-share-bar__seg--locked" style={{ width: `${lockedPct}%` }} />
        <span className="investor-share-bar__seg--available" style={{ width: `${availPct}%` }} />
      </div>
      <div className="investor-share-bar__legend">
        <span className="leg-held">Held {fmt(held)}</span>
        <span className="leg-locked">Locked {fmt(locked)}</span>
        <span className="leg-available">Available {fmt(available)}</span>
        {Number(redeemed) > 0 ? <span>Redeemed {fmt(redeemed)}</span> : null}
      </div>
    </div>
  );
}
